import { sureOf } from "../../../../utils/CommonUtils";
import { DocsBlockItem } from "./SDKDocsBlockItem";
// export type DocsBlockItemDefinitionModel = {
//   id: string
//   props: {
//     [key: string]: object
//   }
//   linksTo?: DocsLinkRef
// }
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f;
        this.id = model.id;
        this.packageId = model.data.packageId;
        this.variantId = (_a = model.data.variantId) !== null && _a !== void 0 ? _a : null;
        this.indentLevel = model.data.indentLevel;
        this.appearance = {
            // TODO - remote model mismatch in Colors (rgba on client vs hex on backend)
            numberOfColumns: (_c = (_b = model.data.appearance) === null || _b === void 0 ? void 0 : _b.numberOfColumns) !== null && _c !== void 0 ? _c : 1,
            itemBackgroundColor: (_e = (_d = model.data.appearance) === null || _d === void 0 ? void 0 : _d.itemBackgroundColor) !== null && _e !== void 0 ? _e : null,
        };
        this.data = ((_f = model.data.items) !== null && _f !== void 0 ? _f : []).map((item) => new DocsBlockItem(item));
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    /** Returns stored data of all properties. This will retrieve properties for item on the first position, ideal for single-item blocks */
    allPropertyDataForSingleItem() {
        var _a, _b;
        return (_b = (_a = this.data[0]) === null || _a === void 0 ? void 0 : _a.props) !== null && _b !== void 0 ? _b : null;
    }
    /** Returns stored data of all properties. This will retrieve properties for item at any position */
    allPropertyDataForItemAtIndex(index) {
        var _a, _b;
        return (_b = (_a = this.data[index]) === null || _a === void 0 ? void 0 : _a.props) !== null && _b !== void 0 ? _b : null;
    }
    /** Returns stored data of a single property. This will retrieve property for item on the first position, ideal for single-item blocks */
    propertyDataForSingleItem(propertyId) {
        var _a, _b;
        return (_b = (_a = this.data[0]) === null || _a === void 0 ? void 0 : _a.props[propertyId]) !== null && _b !== void 0 ? _b : null;
    }
    /** Returns stored data of a single property. This will retrieve property for item at any position */
    propertyDataForItemAtIndex(index, propertyId) {
        var _a, _b;
        return (_b = (_a = this.data[index]) === null || _a === void 0 ? void 0 : _a.props[propertyId]) !== null && _b !== void 0 ? _b : null;
    }
    /** Returns stored link, if any. This will retrieve link for item on the first position, ideal for single-item blocks */
    linkForSingleItem() {
        var _a, _b;
        return (_b = (_a = this.data[0]) === null || _a === void 0 ? void 0 : _a.linksTo) !== null && _b !== void 0 ? _b : null;
    }
    /** Returns stored link, if any. This will retrieve link for item at any position */
    linkForItemAtIndex(index) {
        var _a, _b;
        return (_b = (_a = this.data[index]) === null || _a === void 0 ? void 0 : _a.linksTo) !== null && _b !== void 0 ? _b : null;
    }
    /** Update data for property of specific key and index */
    updatePropertyDataForItemAtIndex(index, propertyId, data) {
        if (this.data[index]) {
            sureOf(this.data[index]).props[propertyId] = data;
        }
    }
    /** Update data for property of specific key and index */
    updatePropertyDataForSingleItem(propertyId, data) {
        if (this.data[0]) {
            this.data[0].props[propertyId] = data;
        }
    }
    /** Update link for item at specific index */
    updateLinkForItemAtIndex(index, link) {
        if (this.data[index]) {
            sureOf(this.data[index]).linksTo = link;
        }
    }
    /** Update link for item at specific index */
    updateLinkForSingleItem(link) {
        if (this.data[0]) {
            sureOf(this.data[0]).linksTo = link;
        }
    }
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a, _b, _c, _d, _e;
        const model = {
            id: this.id,
            type: "Block",
            data: {
                packageId: this.packageId,
                indentLevel: this.indentLevel,
                items: (_a = this.data) !== null && _a !== void 0 ? _a : [],
                appearance: {
                    numberOfColumns: (_c = (_b = this.appearance) === null || _b === void 0 ? void 0 : _b.numberOfColumns) !== null && _c !== void 0 ? _c : 1,
                    itemBackgroundColor: (_e = (_d = this.appearance) === null || _d === void 0 ? void 0 : _d.itemBackgroundColor) !== null && _e !== void 0 ? _e : undefined,
                },
            },
        };
        if (this.variantId) {
            model.data.variantId = this.variantId;
        }
        return model;
    }
}
